<div class="db-site-lock" [ngClass]="{'ds-staging': isStaging}"
     [dsTooltipPosition]="'bottom'"
     [dsTooltipAlign]="'left'"
     [dsTooltipMode]="'hoverStatic'"
     [dsTooltipSize]="'large'"
     [dsTooltipHoveredElement]="'.db-site-lock'"
     [dsTooltip]="wpTooltip">
  <div>
    <div class="db-site-lock-text">
      <i *ngIf="!loading" class="db-icon db-icon-{{!!passwordProtection ? 'ds-locked-border' : 'ds-globus-border'}}"></i>
      <db-loading-dotted-circle *ngIf="loading"
                                [width]="'14'"
                                [size]="'s'"
                                [height]="'14'"
                                [percent]="percent"
      ></db-loading-dotted-circle>
      <span>{{ !!passwordProtection ? ('text_privateVisibility' | dbText) : ('text_publicVisibility' | dbText) }}</span>
    </div>
    <i class="db-icon db-icon-ds-arrow-sharp" ></i>
  </div>
</div>

<ng-template #wpTooltip>
  <div class="db-password-protected-tooltip">
    <div class="db-password-tooltip">
      <ng-container *ngIf="!!hasPayments || demoUser; else reversedOrder">
        <ng-container [ngTemplateOutlet]="publicView"></ng-container>
        <ng-container [ngTemplateOutlet]="privateView"></ng-container>
      </ng-container>

      <ng-template #reversedOrder>
        <ng-container [ngTemplateOutlet]="privateView"></ng-container>
        <ng-container [ngTemplateOutlet]="publicView"></ng-container>
      </ng-template>
    </div>
  </div>
</ng-template>

<ng-template #privateView>
  <div class="db-password-tooltip-wrap"
       [ngClass]="{'active': !!passwordProtection,
                   'loading': !!loading && action === 'enable'}"
       (click)="!passwordProtection && !loading && setupPassProtection('enable')">
    <div>
      <div *ngIf="action !== 'enable'">
        <input class="ds-radio-blue" type="radio" id="private"
               [formControl]="passProtection"
               (click)="$event.preventDefault(); $event.stopPropagation()"
               value="enable" [checked]="passProtection?.value === 'enable'">
        <label for="private"></label>
      </div>
      <db-loading-dotted-circle *ngIf="!!loading && action === 'enable'"
                                class="mt3"
                                [width]="'14'"
                                [size]="'s'"
                                [height]="'14'"
                                [percent]="percent"
      ></db-loading-dotted-circle>
      <div class="db-password-tooltip-info"
           [class.public]="isWVCSite && userSubscription.trialClient">
        <div>
          <h4 class="mb4">{{!passwordProtection ? ('text_privateVisibility' | dbText) : ('text_yourWebsiteIsPrivate' | dbText)}}</h4>
          <p>{{'text_privateVisibilityDesc' | dbText}}<br/>
            <span *ngIf="!!passwordProtection">{{'text_privateWebsiteDescription' | dbText}}</span>
          </p>
        </div>
        <div class="upgrade"
             *ngIf="!hasPayments && isWVCSite && this.userSubscription.trialClient">
          <i class="db-icon db-icon-ds-dimond mr8"></i>
          <p>{{ 'text_upgrade' | dbText }}</p>
        </div>
        <div class="mt16" *ngIf="!!passwordProtection">
          <p class="share-access">{{ 'text_shareAccess' | dbText }}</p>
          <div class="db-copy-info__list">
            <ul>
              <li class="db-copy-info__list-item">
                <h4 class="db-title">{{ 'text_usernamePlaceholder' | dbText }}</h4>
                <p>
                  <input type="text" class="form-control host-name" #inputUsername
                         [value]="passwordProtection?.username">
                  <a [ngxClipboard]="inputUsername" (cbOnSuccess)="copiedUserName()"
                     (click)="isCopiedHostNames = true">
                    {{(isCopiedHostNames? 'text_copied' : 'text_copy') | dbText}}
                  </a>
                </p>
              </li>
              <li class="db-copy-info__list-item">
                <h4 class="db-title">{{ 'text_createProfilePassword' | dbText }}</h4>
                <p>
                  <input type="text" class="form-control" #inputPassword [value]="passwordProtection?.password">
                  <a [ngxClipboard]="inputPassword" (cbOnSuccess)="copiedPassword()"
                     (click)="isCopiedCodes = true">
                    {{(isCopiedCodes? 'text_copied' : 'text_copy') | dbText}}
                  </a>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #publicView>
  <div class="db-password-tooltip-wrap"
       [ngClass]="{'active': !passwordProtection,
       'loading': !!loading && action === 'disable'}"
       (click)="!loading && setupPassProtection('disable')">
    <div>
      <div *ngIf="action !== 'disable'">
        <input class="ds-radio-blue" type="radio" id="public"
               [ngClass]="{'disabled': !hasPayments}"
               [formControl]="passProtection"
               [disabled]="!hasPayments"
               (click)="$event.preventDefault(); $event.stopPropagation()"
               value="disable" [checked]="passProtection?.value === 'disable'">
        <label for="public"></label>
      </div>
      <db-loading-dotted-circle class="mt3" *ngIf="!!loading && action === 'disable'"
                                [width]="'14'"
                                [size]="'s'"
                                [height]="'14'"
                                [percent]="percent"
      ></db-loading-dotted-circle>
      <div class="db-password-tooltip-info public">
        <div>
          <h4 class="mb4">{{!!passwordProtection ? ('text_publicVisibility' | dbText) : ('text_websiteIsPublic' | dbText)}}</h4>
          <p>{{'text_anyoneCanView' | dbText}}</p>
        </div>
      </div>
    </div>
 <!--   <div class="ds-notification-info rounded mt16" *ngIf="userRole?.roleId !== clientRoles?.OWNER && !hasPayments">
      <span>This action is not available for your role. Please contact <br/>the workspace owner for assistance.</span>
    </div>-->
  </div>
</ng-template>
